import { Node } from "postcss";

export class ServiceSection {
    private container: HTMLElement;
    private services: NodeListOf<HTMLElement>;
    private images: NodeListOf<HTMLImageElement>;
    private swipers: NodeListOf<HTMLElement>;

    public constructor(container: HTMLElement) {
        this.container = container;
        this.services = this.container.querySelectorAll(".service");
        this.images = this.container.querySelectorAll(".service-image");
        this.swipers = this.container.querySelectorAll(".service-swiper");

        this.services.forEach((service) => {
            service.addEventListener("click", (e) => {
                const target: HTMLElement = e.target as HTMLElement;

                if (target.classList.contains("active")) {
                    return;
                } else {
                    const serviceName = Array.from(service.classList).find((className) =>
                        className.startsWith("title-")
                    );
                    this.setActiveState(serviceName);
                }
            });
        });
    }

    private setActiveState(className: string) {
        this.toggleActiveStage(this.services, className);
        this.toggleActiveStage(this.images, className);
        this.toggleActiveStage(this.swipers, className);
    }

    private toggleActiveStage(elements, className) {
        elements.forEach((element) => {
            if (element.classList.contains(className)) {
                element.classList.add("active");
            } else {
                element.classList.remove("active");
            }
        });
    }
}
